import PropTypes from "prop-types";

const ExternalLogin = ({ allowToAccessOnce, runSSOFlow }) => {
  const { search } = location;

  if (allowToAccessOnce) {
    runSSOFlow(search);
  }

  return null;
};

ExternalLogin.propTypes = {
  runSSOFlow: PropTypes.func.isRequired,
  allowToAccessOnce: PropTypes.bool.isRequired,
};

export default ExternalLogin;



// WEBPACK FOOTER //
// ./components/login/ExternalLogin.jsx